var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagDk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "M12.522 13.913h19.343C30.842 6.063 24.129 0 16 0c-1.195 0-2.358.132-3.478.38zM8.348 13.913V1.945C3.955 4.343.809 8.74.135 13.913zM8.348 18.087H.135c.674 5.174 3.82 9.57 8.213 11.968zM12.522 18.087V31.62c1.12.248 2.283.38 3.478.38 8.13 0 14.842-6.063 15.865-13.913z"
})));
export default SvgFlagDk;